import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import shopTileImage from '../imgs/shop_tile.jpg'; // Import the image

const Shop: React.FC = () => {
  const shopUrl = "http://www.sportsscenedirect.com/ashridge-park-108-c.asp";

  return (
    // Use flexbox to center the card on the page
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <Card className="text-center shadow-lg" style={{ maxWidth: '400px', border: 'none', borderRadius: '15px' }}>
        <Card.Img 
          variant="top" 
          src={shopTileImage} 
          alt="Ashridge Park FC Merchandise" 
          style={{ borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}
        />
        <Card.Body className="p-4">
          <Card.Title as="h2" className="mb-3" style={{ color: '#254E97' }}>
            VISIT OUR ONLINE SHOP
          </Card.Title>
          <Card.Text>
            Get your official Ashridge Park FC kit, training wear, and merchandise from our partner, Sports Scene.
          </Card.Text>
          <Button 
            href={shopUrl} 
            target="_blank" 
            rel="noopener noreferrer" 
            variant="outline-primary" 
            size="lg"
            className="mt-3"
          >
            Shop Now
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Shop;